/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
export var TEALIUM_SET_UTAG_URL = 'TEALIUM_SET_UTAG_URL';
export var TEALIUM_SET_ENABLED = 'TEALIUM_SET_ENABLED';
export var TEALIUM_SET_UTAG_LOADED = 'TEALIUM_SET_UTAG_LOADED';
export var TEALIUM_SET_PAGE_ID = 'TEALIUM_SET_PAGE_ID';
export var TEALIUM_SET_PAGE_SUB_ID = 'TEALIUM_SET_PAGE_SUB_ID';
export var TEALIUM_UPDATE_PAGE_ID = 'TEALIUM_SET_PAGE_ID';
export var TEALIUM_UPDATE_PAGE_SUB_ID = 'TEALIUM_SET_PAGE_SUB_ID';
export var setTealiumUtagUrl = function setTealiumUtagUrl(url) {
  return {
    type: TEALIUM_SET_UTAG_URL,
    url: url
  };
};
export var setTealiumEnabled = function setTealiumEnabled(enabled) {
  return {
    type: TEALIUM_SET_ENABLED,
    enabled: enabled
  };
};
export var setTealiumUtagLoaded = function setTealiumUtagLoaded() {
  return {
    type: TEALIUM_SET_UTAG_LOADED
  };
};
export var setTealiumPageId = function setTealiumPageId(_ref) {
  var pageId = _ref.pageId,
      pageSubId = _ref.pageSubId;
  return {
    type: TEALIUM_SET_PAGE_ID,
    pageId: pageId,
    pageSubId: pageSubId
  };
};
export var setTealiumPageSubId = function setTealiumPageSubId(_ref2) {
  var pageSubId = _ref2.pageSubId;
  return {
    type: TEALIUM_SET_PAGE_SUB_ID,
    pageSubId: pageSubId
  };
};
export var updateTealiumPageId = function updateTealiumPageId(_ref3) {
  var pageId = _ref3.pageId,
      pageSubId = _ref3.pageSubId;
  return {
    type: TEALIUM_UPDATE_PAGE_ID,
    pageId: pageId,
    pageSubId: pageSubId
  };
};
export var updateTealiumPageSubId = function updateTealiumPageSubId(_ref4) {
  var pageSubId = _ref4.pageSubId;
  return {
    type: TEALIUM_UPDATE_PAGE_SUB_ID,
    pageSubId: pageSubId
  };
};